import { configApiRef, useApi } from '@backstage/core-plugin-api';

export type LinkItem = { name: string; url: string };

export type LinkGroup = { title: string; links: LinkItem[] };

const warned = new Set<string>();

export const useLinkGroups = (): LinkGroup[] => {
  const config = useApi(configApiRef);
  return (config.getOptionalConfigArray('usefulLinks') ?? [])
    .map(group => {
      const title = group.getString('title');
      const links = group.getConfigArray('links').map(link => ({
        name: link.getString('name'),
        url: link.getString('url'),
      }));
      return {
        title,
        links: links.filter(link => {
          if (/^https?:\/\//.test(link.url)) return true;
          const key = `${title}/${link.name}`;
          if (!warned.has(key)) {
            warned.add(key);
            // eslint-disable-next-line no-console
            console.warn(
              `usefulLinks: "${link.name}" in "${title}" ignored, the URL must start with http:// or https://`,
            );
          }
          return false;
        }),
      };
    })
    .filter(group => group.links.length > 0);
};
